import instance from './base';

// 國定假日是系統資料，一年內不會頻繁變動：以年份為 key 暫存 promise，
// 同時進行中的請求也共用；失敗時移除，下次呼叫可重試。兩站共用路徑 /v1/holidays。
const holidayCache = {};

/**
 * 取得某一年的國定假日（有快取）。
 * @param {number} year 西元年
 * @returns {Promise<Array<{date: string, name: string}>>} date 為 YYYY-MM-DD
 */
export function getHolidays(year) {
  if (!holidayCache[year]) {
    holidayCache[year] = instance.get('/v1/holidays', { params: { year } })
      .then((rsp) => rsp.data)
      .catch((err) => {
        delete holidayCache[year];
        throw err;
      });
  }
  return holidayCache[year];
}

/**
 * 取得日期涵蓋的所有年份的國定假日（週跨年時載入兩年）。
 * @param {Date[]} dates
 * @returns {Promise<Array<{date: string, name: string}>>}
 */
export async function getHolidaysForDates(dates) {
  const years = [...new Set(dates.map((d) => d.getFullYear()))];
  const lists = await Promise.all(years.map((y) => getHolidays(y)));
  return [].concat(...lists);
}
